import Footer from "../components/Footer";
import CardPricing from "../components/CardPricing";

type Props = {}

function Pricing({ }: Props) {
    return (
        <div className="bg-black w-screen flex flex-col items-center ">
            <div className="flex flex-col mt-28 items-center">
                <span className="text-white font-bold text-5xl">An affordable event measurement solution:</span>
                <span className="text-white font-regular text-xl mt-8 mb-6">Ideal solutions for every brand and agency.</span>
            </div>

            {/*Cards price*/}
            <div className="flex flex-col mb-8 mt-16">
                <div className="flex flex-row gap-6 items-end">
                    <CardPricing tipo={'OX'} />
                    <CardPricing tipo={'OX1'} />
                    <CardPricing tipo={'OX2'} />
                    <CardPricing tipo={'XO+'} />
                </div>

                <div className="flex flex-col mt-4 justify-center items-center">
                    <span className="font-bold text-xs text-grayText">Need more Users?</span>
                    <span className="font-regular text-xs text-gray30">Add additional users for $19.99 each per month.</span>
                </div>
            </div>
            

            {/*Footer*/}
            <div className='w-11/12 my-7 self-center'>
                <Footer />
            </div>
        </div>
    )
}

export default Pricing